import {createApp} from 'vue'
import './style.css'
// @ts-ignore
import App from './App.vue'

import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import {createPinia} from 'pinia'
import {debounce} from 'ts-debounce'
import {PiniaDebounce} from '@pinia/plugin-debounce'

/* @ts-ignore */
jQuery( document ).ready(function() {
    const pinia = createPinia()
    pinia.use(piniaPluginPersistedState)
    pinia.use(PiniaDebounce(debounce))

    function mountCashbackApp() {
        const app = createApp(App)
        app.use(pinia)
        app.mount('#cashback_app')
        return app;
    }

    const app = mountCashbackApp();
});
